import * as d3 from "d3";
//http://bl.ocks.org/d3noob/a22c42db65eb00d4e369

const Tooltip = function(chart) {

  let div = d3.select(chart.el)
    .append("div")
    .attr("class", "tooltip")
    .style("opacity", 0);

  // set up formatters for the table
  let round = d3.format(",.0f");
  let perc = function(data) {
    if (data == 0) { // avoid NaNs
      return "0%";
    } else if (data < .01) {
      return "<1%";
    } else {
      return d3.format(".0%")(data);
    }
  }

  let customColorHash = {
    'American_Indian_Alaskan_Native_female': "#3C0647",
    'Black_or_African_American_female': "#7D251C",
    'Latino_female': "#004D80",
    'Native_Hawaiian_or_Pacific_Islander_female': "#004D36",
    'Two_or_more_races_female': "#D1B815",
    'Asian_female': "#737373",
    'White_female': "#222222",
    'Total_male': "ghostwhite"
  }

  // build range based on the real hash
  let customColorRange = [];
  chart.keys.forEach(key => {
    // get my custom color for each key
    customColorRange.push(customColorHash[key]);
  })

  let newColorScale = d3.scaleOrdinal()
    .range(customColorRange)
    .domain(chart.keys);

  function highlightBars() {
    // select all series and redo the colors 
    d3.selectAll(".serie")
      .attr("fill", (d, i) => {
        return newColorScale(d.key);
      });
  }


  function unhighlightBars(d) {
    // return to normal
    d3.selectAll(".serie")
      .attr("fill", d => {
        return chart.colorScale(d.key);
      })
  }


  function highlightCompany(d) {
    let idstring = d.data.company.replace(/[\s\.23]/g, '');

    let company = `#${idstring}`;

    d3.select(company)
      .attr("class", "highlightedCompany");
  }

  function removeHighlightCompany(d) {
    let idstring = d.data.company.replace(/[\s\.23]/g, '');
    let company = `#${idstring}`;

    d3.select(company)
      .classed("highlightedCompany", false);
  }

  function populateTooltip(d, i) {
    // convenience 
    let data = d.data;
    let html = `
        <span id="closeme">X</span>
        <table class="tooltip">
        <tbody>
          <th>
            <th>Percent</th>
            <th>Total</th>
          </th>
          <tr style="background-color:${customColorHash['American_Indian_Alaskan_Native_female']}">
            <td>Native American</td>
            <td>${perc(data.meta.percent_native_female)}</td>
            <td>${round(data.American_Indian_Alaskan_Native_female)}</td>
          </tr>
          <tr style="background-color:${customColorHash['Asian_female']}">
            <td>Asian</td>
            <td>${perc(data.meta.percent_asian_female)}</td>
            <td>${round(data.Asian_female)}</td>
          </tr>
          <tr style="background-color: ${customColorHash['Black_or_African_American_female']}">
            <td>Black</td>
            <td>${perc(data.meta.percent_black_female)}</td>
            <td>${round(data.Black_or_African_American_female)}</td>
          </tr>
          <tr style="background-color: ${customColorHash['Latino_female']}">
            <td>Latina</td>
            <td>${perc(data.meta.percent_latino_female)}</td>
            <td>${round(data.Latino_female)}</td>
          </tr>
          <tr style="background-color: ${customColorHash['Native_Hawaiian_or_Pacific_Islander_female']}">
            <td>Pacific Islander</td>
            <td>${perc(data.meta.percent_pac_female)}</td>
            <td>${round(data.Native_Hawaiian_or_Pacific_Islander_female)}</td>
          </tr>
          <tr style="background-color: ${customColorHash['Two_or_more_races_female']}">
            <td>Two or more races</td>
            <td>${perc(data.meta.two_female)}</td>
            <td>${round(data.Two_or_more_races_female)}</td>
          </tr>
          <tr style="background-color: ${customColorHash['White_female']}">
            <td >White</td>
            <td >${perc(data.meta.percent_white_female)}</td>
            <td >${round(data.White_female)}</td>
          </tr>

        </tbody>
        </table>`;

    return html;
  }

  function hideTooltip() {
    div.transition()
      .duration(500)
      .style("pointer-events", "none")
      .style("opacity", 0);
  }


  // return this function. Essentially an "init" function 
  function tooltip() {
    console.log("Tooltip is active");
    // add event
    chart.bars
      .on("mouseout", d => {
        let data = d;

        unhighlightBars();
        removeHighlightCompany(data);

        console.log("mouseout");

        hideTooltip();

      })
      .on("mouseover", (d, i) => {
        let data = d;

        let content = populateTooltip(data);
        div.html(content);
        // debugger;

        // calculate the middle point
        let middle = chart.xScale(0.5);
        // calculate position of svg relative to doc
        let svgbox = chart.svg.node().getBoundingClientRect();
        let leftmargin = chart.margin.left;
        let toolbox = div.node().getBoundingClientRect();
        let toolleft = middle + svgbox.left - (toolbox.width / 2) + leftmargin;


        // height is harder
        // get company
        let company = d.data.company;
        // calculate y position relative to svg
        let y = chart.yScale(company);
        let svgheight = svgbox.top;

        // calculate scroll ofset
        let scroll = window.pageYOffset;

        //get height of the tooltip itself
        let toolheight = div.node().getBoundingClientRect().height;
        // get height of bar
        let barheight = chart.yScale.bandwidth()
        // height of triange:
        let triangle = 8;
        // margin top
        let margintop = chart.margin.top;
        // add it up
        let tooltop = svgheight + scroll + y - toolheight + margintop - barheight - triangle;

        // reveal tooltip
        div.style("left", toolleft + 'px')
          .style("top", tooltop + "px")
          .style("pointer-events", "initial")
          .transition()
          .duration(200)
          .style("opacity", 0.9);

        highlightBars();
        highlightCompany(data);

      });


    div.on("click", hideTooltip);
  }

  // add functionality here 
  tooltip.sayHello = function() {
    console.log("hello");
  }


  tooltip.hide = hideTooltip;


  return tooltip;
}

export default Tooltip;



// WEBPACK FOOTER //
// ./app/scripts/Tooltip.js